/** 日本 Ro（gameId 467）用户中心协议外跳配置 */
export const JP_RO_GAME_ID = 467;

export const JP_RO_USER_CENTER_AGREEMENT_LIST = [
  {
    id: 'jpRoAppTerms',
    label: 'アプリケーション共通利用規約',
    link: 'https://mobile.gungho.jp/reg/rules/terms.html'
  },
  {
    id: 'jpRoPrivacy',
    label: 'プライバシー・ポリシー',
    link: 'https://mobile.gungho.jp/reg/ragnarokw/privacy.html'
  },
  {
    id: 'jpRoShikin',
    label: '資金決済法に基づく表示',
    link: 'https://mobile.gungho.jp/reg/shikin/'
  },
  {
    id: 'jpRoTrade',
    label: '特定商取引法に基づく表示',
    link: 'https://mobile.gungho.jp/reg/trade/'
  }
];

export const isJpRoGame = gameId => +gameId === JP_RO_GAME_ID;
